import type {EditServiceDescriptionFormPayload} from "./edit-service-description.schema";

import type {Language} from "@project/sdk/engineering";
import {editServiceDescription} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceKeys, serviceMutationKeys} from "../../../../../service-keys";

export function editServiceDescriptionMutationOptions(id: string, language: Language) {
  return mutationOptions({
    mutationKey: serviceMutationKeys.editServiceDescription,
    mutationFn: (payload: EditServiceDescriptionFormPayload) =>
      editServiceDescription(id, language, payload),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: serviceKeys.detail(id)}),
        client.invalidateQueries({queryKey: serviceKeys.lists()}),
      ]);
    },
  });
}
